// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__uFDcB","productName":"Table_productName__3Ifuu"};